import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Notice, Separator } from 'telia-front-react';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { getIsDealerFromAuth, getCustomerIdFromAuth, isDealerWithoutCustomer } from '../util/InternetCalculatorUtil';
export const DealerWithoutCustomerError = (props) => {
    const translate = React.useContext(TranslationsContext).translate;
    const { auth } = useInternetCalculator();
    const isDealer = getIsDealerFromAuth(auth);
    const customerId = getCustomerIdFromAuth(auth);
    if (!props.addressSelected || !isDealerWithoutCustomer(isDealer, customerId)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "small", color: "invisible" }),
        React.createElement(Notice, { type: "error" }, translate('internetCalculator.dealerWithoutCustomerError')),
        React.createElement(Separator, { spacing: "small", color: "invisible" })));
};
